export class POSDownload {
  workOrderId: string = '';
  workOrderNumber: string = '';
  visitId: string = '';
  visitState: string = '';
}
